import React from 'react';
import '../../App.css';
import Form from 'react-bootstrap/Form';


export default function Parceiros() {
    return <>
        <body className='parceiros'>
            <h1 className='title'>Parceiros</h1>
            <img class="parceirosImg" src={"./ufmg.png"} />
        </body>
    </>;

}